import { RootState } from "integrations/redux"
import { DecisionOption, DecisionStatus } from "./decisionSlice"

export const selectLastDecision = (state: RootState): DecisionOption | undefined =>
    state.application.decision.last
export const selectDecisionContextTitle = (state: RootState): string | undefined =>
    state.application.decision.title
export const selectDecisionContextDescription = (state: RootState): string | undefined =>
    state.application.decision.description
export const selectDecisionOptions = (state: RootState): DecisionOption[] =>
    state.application.decision.options
export const selectDecisionStatus = (state: RootState): DecisionStatus =>
    state.application.decision.status
export const selectDecisionId = (state: RootState): string | undefined =>
    state.application.decision.id
